import api from './api';

const societyService = {
  /**
   * Get all societies
   * @returns {Promise} Array of societies
   */
  getSocieties: async () => {
    const response = await api.get('/api/societies');
    return response.data;
  },

  /**
   * Get societies by pincode (public endpoint)
   * @param {string} pincode - 6-digit pincode
   * @returns {Promise} Array of societies in that pincode
   */
  getSocietiesByPincode: async (pincode) => {
    const response = await api.get(`/api/societies/by-pincode/${pincode}`);
    return response.data;
  },

  /**
   * Get unique pincodes with society counts
   * @returns {Promise} Array of pincodes with societyCount and societies array
   */
  getPincodes: async () => {
    const response = await api.get('/api/societies/pincodes');
    return response.data;
  },

  /**
   * Get single society by ID
   * @param {string} id - Society MongoDB ID
   * @returns {Promise} Society data
   */
  getSocietyById: async (id) => {
    const response = await api.get(`/api/societies/${id}`);
    return response.data;
  },

  /**
   * Create a new society
   * @param {Object} societyData - Society details
   * @param {string} societyData.name - Society name
   * @param {string} societyData.additionalAddress - Additional address info
   * @param {string} societyData.pincode - Pincode
   * @returns {Promise} Created society data
   */
  createSociety: async (societyData) => {
    const response = await api.post('/api/societies', societyData);
    return response.data;
  },

  /**
   * Update a society
   * @param {string} id - Society MongoDB ID
   * @param {Object} updateData - Fields to update
   * @returns {Promise} Updated society data
   */
  updateSociety: async (id, updateData) => {
    const response = await api.put(`/api/societies/${id}`, updateData);
    return response.data;
  },

  /**
   * Delete a society
   * @param {string} id - Society MongoDB ID
   * @returns {Promise} Deletion confirmation
   */
  deleteSociety: async (id) => {
    const response = await api.delete(`/api/societies/${id}`);
    return response.data;
  },
};

export default societyService;
